import React from 'react';

import PropTypes from 'prop-types';

export default function CartIcon({
  color = 'currentColor',
  size = '1em',
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 16"
      fill="none"
    >
      <path
        data-icon=""
        d="M16.5037 9.41622L17.981 2.91622C18.0877 2.44691 17.731 2 17.2497 2H4.97525L4.68881 0.599688C4.61744 0.250656 4.31031 0 3.95403 0H0.75C0.335781 0 0 0.335781 0 0.75V1.25C0 1.66422 0.335781 2 0.75 2H2.93384L5.12909 12.7323C4.60391 13.0344 4.25 13.6007 4.25 14.25C4.25 15.2165 5.0335 16 6 16C6.9665 16 7.75 15.2165 7.75 14.25C7.75 13.7602 7.54853 13.3177 7.22425 13H13.7757C13.4515 13.3177 13.25 13.7602 13.25 14.25C13.25 15.2165 14.0335 16 15 16C15.9665 16 16.75 15.2165 16.75 14.25C16.75 13.5571 16.3472 12.9584 15.7632 12.6748L15.9356 11.9162C16.0422 11.4469 15.6855 11 15.2042 11H6.81616L6.61163 10H15.7724C16.1226 10 16.4262 9.75769 16.5037 9.41622Z"
        fill={color}
      />
    </svg>
  );
}

CartIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
